/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var apiTrackURL = siteURL + '/lvl3/lvl3/js';


(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        this.initSiteMenu();

        $(document).on('click', '.r-tabs__link', function(e){
          e.preventDefault();

          var index = $(this).parent().index() + 1;

          console.log(index);

          $('.res__tab--result').css('display','none');
          $('.res__tab--result-' + index).css('display','block');


          $('.r-tabs__item').removeClass('selected');
          $('.r-tabs__item:nth-child(' + index + ')').addClass('selected');
        });

        $(document).on('click', '.toggle-m-nav', function(e) {
          e.preventDefault();

          $(this).toggleClass('open');
          $('.public-nav').toggleClass('open');
        })


        // Postcard Library

        $(document).on('click', '.d-popup__link', function (e) {

          e.preventDefault();

          var type = $(this).data('type');

          $('.page-head').css('z-index', 90);

          $('.postcard__link--library').css('display','inline');

          function decodeHtml(html) {
              var txt = document.createElement("textarea");
              txt.innerHTML = html;
              return txt.value;
          }



          if(type == 'postcard') {
            $('.d-popup_img').attr('src', $(this).data('content'));
            $('.postcard-popup').addClass('show');
            $('.text-post__body').html(decodeHtml($(this).data('text')));

          } else {

            $('.video-popup').addClass('show');
            var video = decodeHtml($(this).data('content'));
            $('.text-post__body').html(decodeHtml($(this).data('text')));

            console.log($(this).data('content').length);

            if($(this).data('text').length < 10) {
              $('.postcard__link--library').css('display','none');
            } else {
              $('.postcard__link--library').css('display','block');
            }

            setTimeout(function () {
                 $('.d-popup_video').html(video);

                 $(".d-popup_video").fitVids();
            }, 200)
            //$('.d-popup_video').html(video);

            console.log(video);
          }

          console.log(type);

        });


        $(document).on('click', '.text-post__overlay, .text-post__btn', function (e){
          e.preventDefault();
          $('.text-post').removeClass('show');
          $('.page-head').css('z-index', 9000);

          $('.d-popup_img').attr('src', '');
          $('.d-popup_video').html('');

          $('.text-post__content').css('display', 'none');
          $('.library-img').css('display', 'block');


        });

        $(document).on('click', '.postcard__link--library', function (e) {
          e.preventDefault();

          $('.text-post__content').css('display', 'block');
          $('.library-img').css('display', 'none');

          $('.d-popup_video').html('');

          $(this).css('display','none');

        });

      },

      initSiteMenu : function () {


        $(document).on('click', '.top-nav__menu-btn', function (e){


          e.preventDefault();
          $('.site-menu').addClass('show');
        });

        $(document).on('click', '.site-menu__hide', function (e) {
          e.preventDefault();
          $('.site-menu').removeClass('show');
        });

         $(document).on('click', '.top-nav__phone-btn', function (e){
          e.preventDefault();
          $('.phonecall').addClass('show');
        });

         $(document).on('click', '.phonecall__overlay, .phonecall__btn', function (e){
          e.preventDefault();
          $('.phonecall').removeClass('show');
        });

        $(document).on('click', '.site-menu__hide', function (e) {
          e.preventDefault();
          $('.site-menu').removeClass('show');
        });

        $(document).on('click', '.site-menu--logout', function (e) {
          e.preventDefault();

          $.ajax({
            method: "GET",
            url: '/cookie.php',
            success: function (data) {
              console.log('logout');

              window.location = '/logout';
            },
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true
          });
        });

        $(document).on('click', '.nav-action--signup', function (e) {
          e.preventDefault();

          $.ajax({
            method: "GET",
            url: '/cookie.php',
            success: function (data) {
              console.log('logout');

              window.location = '/intervention';
            },
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true
          });
        });

      },


      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page


      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },

    'faqs': {

      init: function() {

        $('.faq__link, .faq__icon').on('click', function (e) {

          e.preventDefault();

          $(this).closest('.faq__item').toggleClass('active');
        });
      }

    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page

        $(document).on('click', '.s-group__link', function (e) {

          e.preventDefault();
          $(this).parent().find('.s-group__overlay').addClass('show');
        });

        $(document).on('click', '.s-group__cancel', function (e) {

          e.preventDefault();
          $(this).closest('.s-group__overlay').removeClass('show');
        });
      }
    },

    'dashboard': {
      init: function() {
        // JavaScript to be fired on the about us page


      }
    },

    'goals': {
      init: function() {
        // JavaScript to be fired on the about us page

        $(document).on('click', '.btn--goal', function (e) {
          e.preventDefault();

          var item = $(this).closest('.g-reflect');
          var step = Number(item.data('step'));
          var nextItem = $('.content-wrapper').find("[data-step='" + (step + 1) + "']");

          item.addClass('pt-moveToLeftFade');
          item.removeClass('pt-moveFromRightFade');
          item.removeClass('active');
          nextItem.addClass('active');
          nextItem.removeClass('inactive');
          nextItem.addClass('active pt-moveFromRightFade');

          // Set Goal Answers
          var leadValue;
          var oAnswers = [];

          switch (step) {
            case 1:
                leadValue = $('input[name="completed"]:checked').val();
                break;
            case 2:
                leadValue = $('textarea[name="what"]').val();
                break;
            case 3:
                leadValue = $('textarea[name="how"]').val();;
                break;
          }

          if(leadValue) {
            var alias = item.data('lead');
            setAnswers(alias, leadValue);
          }

          // Last Step
          if((step + 1) == 5) {
            setTimeout(function () {
               $('.submit-goal').addClass('activated');
            }, 1000);
          }

        });


        // Goal Submit
        $(document).on('click', '.submit-goal', function (e) {
          e.preventDefault();

          var item = $('.g-reflect:last');
          var alias = item.data('lead');
          var leadValue = $('textarea[name="build"]').val();

          setAnswers(alias, leadValue);


          $(this).addClass('loading');

          $.ajax({
            method: "POST",
            url: apiTrackURL,
            data: oAnswers,
            success: function (data) {
              window.location = '/dashboard';
            },
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true
          });

          //window.location = '/dashboard';


        });



        var el = document.querySelector('#rating'),
            leadValue = 3,
            currentRating = 0,
            maxRating= 5;

        var callback = function(rating) {
          var item = $(el).closest('.g-reflect');
          var alias = item.data('lead');
          var leadValue = rating;


          setAnswers(alias, leadValue);
        };

        // rating instance
        var myRating = rating(el, currentRating, maxRating, callback);
        myRating.setRating(leadValue);


        function setAnswers (alias, leadValue) {

          oAnswers[alias] = leadValue;

          console.log(oAnswers);
        }



      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {

      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


function syncLvl3ID (id) {

  if(typeof oUser === 'undefined' || !oUser) return false;

  var _self = this;

  if(parseInt(oUser.id) !== parseInt(id)) {

    var data = {
      action   : 'sync_id',
      security : MyAjax.security,
      lvl3ID : id
    };

    $.post(MyAjax.ajaxurl, data, function(response) {
      console.log('New ID synced with WP: ' + id);
    });
  }

}


;(function ($) {
  'use strict';

  $.fn.idle = function (options) {
    var defaults = {
        idle: 60000, //idle time in ms
        events: 'mousemove keydown mousedown touchstart', //events that will trigger the idle resetter
        onIdle: function () {}, //callback function to be executed after idle time
        onActive: function () {}, //callback function to be executed after back from idleness
        onActivity: function () {}, //callback function to be executed after back from idleness
        onHide: function () {}, //callback function to be executed when window is hidden
        onShow: function () {}, //callback function to be executed when window is visible
        keepTracking: true, //set it to false if you want to track only the first time
        startAtIdle: false,
        recurIdleCall: false
    },
    idle = options.startAtIdle || false,
    visible = !options.startAtIdle || true,
    settings = $.extend({}, defaults, options),
    lastId = null,
    resetTimeout,
    timeout;

    //event to clear all idle events
    $(this).on( "idle:stop", {}, function( event) {
      $(this).off(settings.events);
      settings.keepTracking = false;
      resetTimeout(lastId, settings);
    });

    resetTimeout = function (id, settings) {
      settings.onActivity.call();
      if (idle) {
        settings.onActive.call();
        idle = false;
      }
      clearTimeout(id);
      if(settings.keepTracking) {
        return timeout(settings);
      }
    };

    timeout = function (settings) {
      var timer = (settings.recurIdleCall ? setInterval : setTimeout), id;
      id = timer(function () {
        idle = true;
        settings.onIdle.call();
      }, settings.idle);
      return id;
    };

    return this.each(function () {
      lastId = timeout(settings);
      $(this).on(settings.events, function (e) {
        lastId = resetTimeout(lastId, settings);
      });
      if (settings.onShow || settings.onHide) {
        $(document).on("visibilitychange webkitvisibilitychange mozvisibilitychange msvisibilitychange", function () {
          if (document.hidden || document.webkitHidden || document.mozHidden || document.msHidden) {
            if (visible) {
              visible = false;
              settings.onHide.call();
            }
          } else {
            if (!visible) {
              visible = true;
              settings.onShow.call();
            }
          }
        });
      }
    });

};
}(jQuery));
